import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './languages/en.js'
import ar from './languages/ar.js'
import es from './languages/es.js'
import el from './languages/el.js'
import et from './languages/et.js'
import id from './languages/id.js'

// import zh from './languages/zh.js'
// import pt from './languages/pt.js'

Vue.use(VueI18n);

const messages = {

	'en': en ,
	'es': es ,
	// 'zh': zh ,
	'ar': ar ,
	// 'pt': pt ,
	'el': el,
	'et': et,
	'id': id,

	// 'ge': {},
	// 'fr': {},
	// 'gr': {}
};

const i18n = new VueI18n({
	locale: 'en', // set locale
	fallbackLocale: 'en', // set fallback locale
	messages, // set locale messages
});

export default i18n;


// WEBPACK FOOTER //
// ./src/plugins/lang/i18n.js